export default "__VITE_PUBLIC_ASSET__2a524312__"